import React from 'react';
import { getTdActiveRowStyles, getTdFixedRowStyles, getTdDivStyles, getTdStyles, getTdSwitcherStyles } from '../../../helpers';
import css from '../../GridTbody.module.scss';
import OpenSwitcher from '../../../open/OpenSwitcher/OpenSwitcher';
import GridSwitcher from '../../../../GridSwitcher';
import { t } from '../../../../../../common/components/T';
import { TdComponent } from '../../../wrappers';

const TdGridComponent = ({
    activeTr,
    cellData,
    cellIndex,
    fixedLastColumnShow,
    getHandlersTD,
    gridName,
    gridStyles,
    handlers,
    index,
    isFixedLastColumnShow,
    lineOffsetCalc,
    margin,
    openSwitcher,
    refTable,
    refTableChild,
    rowData,
    setActiveTr,
    setGridData,
    sticky,
    tbody,
    thead,
    translation,
    variant,
    viewData,
    widthArr,
    isFixedColumn
}) => {
    return (
        <React.Fragment key={`gridCell${cellIndex}`}>
            {thead[cellIndex]?.name === cellData && (
                <TdComponent
                    {...getHandlersTD(rowData, cellData, index, cellIndex)}
                    sticky={sticky}
                    {...{
                        [isFixedColumn ? 'data-copy-fixed' : 'data-copy']:
                            sticky?.rightStickyColumnName === cellData ? `${gridName}` : undefined
                    }}
                    {...getTdStyles(css, rowData, cellData, cellIndex, gridStyles, thead, widthArr, sticky)}
                >
                    {!isFixedColumn && rowData.activeRow && rowData.activeRow !== 'disabled' && !rowData?.activeRow?.disabled && (
                        <div {...getTdActiveRowStyles(css, rowData, cellData, cellIndex, gridStyles, thead)} />
                    )}

                    {rowData?.links?.data &&
                    'data' in rowData?.links &&
                    'post' in rowData?.links?.data &&
                    'reject' in rowData?.links?.data &&
                    !gridName.endsWith('-last') ? (
                        <div {...getTdFixedRowStyles(css, cellIndex, gridStyles, thead, 'openFinanceDoc')} />
                    ) : null}

                    <div {...getTdDivStyles(css, rowData, cellData, cellIndex, gridStyles, thead, tbody, margin, openSwitcher)}>
                        {cellIndex === 0 && openSwitcher && sticky?.rightStickyColumnName !== cellData && (
                            <OpenSwitcher
                                partnersCount={rowData.partner_stats?.descendants_count}
                                viewData={viewData}
                                setGridData={setGridData}
                                variant={variant}
                                afterOpenSwitherClick={(data) => openSwitcher.afterOpenSwitherClick(rowData, data)}
                                openSwitcher={openSwitcher}
                                rowData={rowData}
                                setActiveTr={setActiveTr}
                                lineOffset={lineOffsetCalc(index)}
                                levelOffset={tbody[0].depth}
                                loadingStructure={openSwitcher.loadingStructure}
                                setLoadingStructure={openSwitcher.setLoadingStructure}
                                gridStyles={gridStyles}
                                cellData={cellData}
                            />
                        )}
                        <div {...getTdSwitcherStyles(css, rowData, cellData, cellIndex, gridStyles)}>
                            <GridSwitcher
                                rowData={rowData}
                                idx={cellIndex}
                                alias={rowData.id}
                                val={
                                    typeof rowData[`${cellData}`] === 'object'
                                        ? {
                                              ...rowData[`${cellData}`]
                                          }
                                        : rowData[`${cellData}`]
                                }
                                rowIndex={index}
                                tbody={tbody}
                                thead={thead}
                                handlers={handlers}
                                setGridData={setGridData}
                                activeTr={activeTr}
                                setActiveTr={setActiveTr}
                                gridStyles={gridStyles}
                                align={
                                    (cellIndex === 0 && !['center', 'right'].includes(thead[cellIndex]?.align)) ||
                                    thead[cellIndex]?.align === 'left'
                                        ? 'left'
                                        : thead[cellIndex]?.align || 'left'
                                }
                                refTable={refTable}
                                gridName={gridName}
                                refTableChild={refTableChild}
                                translation={translation}
                                fixedLastColumnShow={fixedLastColumnShow}
                                isFixedLastColumnShow={isFixedLastColumnShow}
                            />
                        </div>
                        {thead[cellIndex]?.type === 'login' && cellIndex === 0 ? (
                            !!rowData.deleted ? (
                                <p className={css.deleteUserLabel}>
                                    {t('gridDeletedUser', 'Удален', 'widget', translation, 'grid')}
                                </p>
                            ) : !!rowData.blocked ? (
                                <p className={css.blockedUserLabel}>
                                    {t('gridBlockedUser', 'Заблокирован', 'widget', translation, 'grid')}
                                </p>
                            ) : rowData.is_new_partner ? (
                                <p className={css.newUserLabel}>{t('gridNewUser', 'Новый', 'widget', translation, 'grid')}</p>
                            ) : null
                        ) : null}
                    </div>
                </TdComponent>
            )}
        </React.Fragment>
    );
};

export default TdGridComponent;
